/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/campaign_stats" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdCampaignStats } from "./constants";
import type { EmailIpWarmingCampaignStatsResult, EmailIpWarmingCampaignStatsResultErrors } from "./types";
import { isEmailIpWarmingCampaignStatsResult } from "./validators";

export const getEmailIpWarmingCampaignStats = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdCampaignStats,
  createGetFetcherFunctionWithShadowError<EmailIpWarmingCampaignStatsResultErrors>()(
    // `planId` is an optional trailing path segment, modeled as a string rest arg: the cache-key param
    // type the fetcher adapter infers excludes `undefined`, so a `planId?: string` arg is rejected.
    (
      signal: AbortSignal,
      appGroupId: string,
      ...[planId]: string[]
    ): Promise<EmailIpWarmingCampaignStatsResult> => {
      return fetch(
        `/email/ip_warming/${appGroupId}/campaign_stats${planId ? `/${planId}` : ""}`,
        "GET",
        {},
        { signal }
      );
    }
  ),
  isEmailIpWarmingCampaignStatsResult
);
